import Model  from '@/utils/models';

export default class Product extends Model { 
    backend = '/survey/kompetisi/';           
    
    nodes(params={}){
      return this.api.get('/master/node/index', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
    }

    node(params={}){
      return this.api.get('/master/node/view', params).then(res => {          
          return res.status == 200 ? res.data : {};
      });
  }
}

